import { Compass, Map, Wrench, Award, Eye, Zap, Rocket, PiggyBank } from 'lucide-react';

const BADGE_ICONS = {
  pathfinder: Compass, explorer: Map, builder: Wrench, aligned: Award,
  opportunity_seeker: Eye, skill_builder: Zap, money_smart: PiggyBank, launch_ready: Rocket,
};

// Each badge gets its own vivid color so the shelf feels alive.
const BADGE_COLORS = {
  pathfinder: '#0089FB',
  explorer: '#17CCF4',
  builder: '#2FE0A8',
  aligned: '#A78BFA',
  opportunity_seeker: '#FFC24B',
  skill_builder: '#FF6B9D',
  money_smart: '#FBBF24',
  launch_ready: '#FF6B5E',
};

const hexToRgba = (hex, a) => {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
};

/** BadgeShelf, earned/locked achievement badges as glowing, multi-color glass tiles. */
export default function BadgeShelf({ badges = [] }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3" data-testid="badge-shelf">
      {badges.map((b) => {
        const Icon = BADGE_ICONS[b.key] || Award;
        const color = BADGE_COLORS[b.key] || '#17CCF4';
        return (
          <div
            key={b.key}
            className="rounded-2xl border p-4 flex flex-col items-center text-center transition-all hover:-translate-y-0.5"
            style={{
              background: b.earned
                ? `linear-gradient(160deg, ${hexToRgba(color, 0.16)}, rgba(4,16,31,0.85))`
                : 'rgba(4,16,31,0.6)',
              borderColor: b.earned ? hexToRgba(color, 0.5) : 'rgba(143,176,206,0.18)',
              boxShadow: b.earned ? `0 0 18px ${hexToRgba(color, 0.28)}` : 'none',
              opacity: b.earned ? 1 : 0.5,
            }}
            data-testid={`badge-${b.key}`}
          >
            <div
              className="w-12 h-12 rounded-xl flex items-center justify-center mb-2"
              style={{
                background: b.earned ? hexToRgba(color, 0.22) : 'rgba(143,176,206,0.1)',
                color: b.earned ? color : '#C6D4E8',
                boxShadow: b.earned ? `0 0 14px ${hexToRgba(color, 0.35)}` : 'none',
              }}
            >
              <Icon className="w-5 h-5" />
            </div>
            <p className={`text-sm font-semibold ${b.earned ? 'text-white' : 'text-slate-300'}`}>{b.name}</p>
            <p className="text-[11px] mt-0.5 leading-tight" style={{ color: b.earned ? '#C6D4E8' : '#C6D4E8' }}>{b.desc}</p>
          </div>
        );
      })}
    </div>
  );
}
